module.exports = Transform;

function Transform() {
  this.x = 0;
  this.y = 0;
  this.scale = 1;
}



//////////////////
// WEBPACK FOOTER
// /Users/anvaka/projects/panzoom/lib/transform.js
// module id = 132
// module chunks = 2